"use strict";
export function wrapScientificNotation(value) {
  return parseFloat(value.toString()).toLocaleString("fullwide", { useGrouping: false }).replace(",", ".").replace(" ", "");
}
